<template>
  <transition name="fade">
    <v-layout key="screen" v-if="loading.loadings.length" class="video-transcoder-loading-screen">
      <v-layout column class="loading-screen-block width-100 relative global global-loading">
        <transition-group name="fade">
          <v-layout column justify-end key="global-enabled" class="global-loading-part px-4" v-if="loading.status() === true">
            <h1 class="display-2 font-weight-light text-xs-center pb-3" :style="`color: ${loading.active().color || '#000'}`">{{loading.active().title}}</h1>
            <v-progress-linear
              :value="loading.progress()"
              :color="loading.active().color"
            ></v-progress-linear>
            <div class="text-xs-center">
              <v-btn outline :color="loading.active().color" @click="handleCancel(loading.active().cancel)">Cancel</v-btn>
            </div>
          </v-layout>
          <v-layout column justify-end key="global-success" class="global-loading-part px-4 pb-5" v-else-if="loading.status() === 'success'">
            <h1 class="display-2 font-weight-light text-xs-center success--text pb-3">Success!</h1>
            <v-progress-linear
              :value="loading.progress()"
              color="success"
            ></v-progress-linear>
          </v-layout>
          <v-layout column justify-end key="global-error" class="global-loading-part px-4 pb-5" v-else-if="loading.status() === 'error'">
            <h1 class="display-2 font-weight-light text-xs-center error--text pb-3">{{`${loading.active().title} error`}}</h1>
            <div>
              <p>{{loading.active().error || 'Unable to upload video at this time.'}}</p>
              <div class="text-xs-center">
                <v-btn id="loading-screen-cancel" color="error" outline @click="handleCancel(loading.active().cancel)">Cancel</v-btn>
              </div>
            </div>
            <v-progress-linear
              :value="loading.progress()"
              color="error"
            ></v-progress-linear>
          </v-layout>
        </transition-group>
      </v-layout>
      <v-layout class="loading-screen-block loadings width-100">
        <v-layout column class="full-height relative" justify-center v-for="l in loading.loadings" :key="l.key">
          <transition-group name="fade">
            <div :key="`${l.key}-enabled`" class="loading-part" v-if="l.status === true">
              <v-progress-circular
                class="loading-spinner"
                :rotate="360"
                :size="128"
                :width="5"
                :value="(l.progress !== false) ? l.progress : 0"
                :indeterminate="l.progress === false || l.progress === 100"
                :color="l.color"
              >
                <span class="font-weight-thin subheading"  v-if="l.progress !== 100">
                  {{l.progress}}%
                </span>
                <span class="font-weight-thin body-1" v-if="l.progress === 100">
                  Finalizing
                </span>
              </v-progress-circular>
            </div>
            <div :key="`${l.key}-success`" class="loading-part loading-inactive" v-else-if="l.status === 'success'">
              <v-progress-circular
                class="loading-spinner"
                :rotate="360"
                :size="128"
                :width="5"
                :value="100"
                :indeterminate="false"
                :color="l.color"
              >
                <v-icon :color="l.color" size="64">
                  check
                </v-icon>
              </v-progress-circular>
              <h3 class="mt-2 font-weight-light text-xs-center subheading" :style="`color: ${l.color || '#000'}`">{{l.success}}!</h3>
            </div>
            <div :key="`${l.key}-error`" class="loading-part" v-else-if="l.status === 'error'">
              <v-progress-circular
                class="loading-spinner"
                :rotate="360"
                :size="128"
                :width="5"
                :value="100"
                :indeterminate="false"
                color="error"
              >
                <v-icon color="error" :size="64">
                  clear
                </v-icon>
              </v-progress-circular>
            </div>
            <div :key="`${l.key}-disabled`" class="loading-part loading-inactive" v-else-if="l.status === false">
              <v-progress-circular
                class="loading-spinner"
                :rotate="360"
                :size="128"
                :width="5"
                :value="0"
                :indeterminate="false"
                color="grey lighten-1"
              >
                <span class="headline font-weight-thin">
                  <v-icon color="grey lighten-1">remove</v-icon>
                </span>
              </v-progress-circular>
            </div>
          </transition-group>
        </v-layout>
      </v-layout>
    </v-layout>
  </transition>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import EventBus from '@snippets/js/eventBus';

export default {
  name: 'loading-screen',
	computed: {
    ...mapState('videoTranscoder', [
      'loading'
    ]),
		// ...mapGetters('videoTranscoder', [
    //   'compact'
    // ]),
    compact() {
      return true;
    }
	},
	methods: {
    ...mapMutations('videoTranscoder', [
      'toggleLoading',
      'updateLoadingByIndex'
    ]),
    handleCancel(cancel) {
      if (cancel && typeof cancel === 'function') {
        cancel()
        .then(() => {
          EventBus.$emit('cancel-transcode');
          this.toggleLoading();
        })
      } else {
        EventBus.$emit('cancel-transcode');
        this.toggleLoading();
      }
    }
	}
};
</script>


<style lang="scss" scoped>
	.video-transcoder-loading-screen {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background: rgba(255,255,255,0.9);
		z-index: 10;
		pointer-events: none;
		flex-direction: column;

    .loading-screen-block {
      &.global {
        height: 50%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      &.loadings {
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
      }
    }

    .relative {
      position: relative;
    }

    .full-height {
      height: 100%;
    }

    .loading-screen-subblock {
      position: absolute;
      margin: auto;
    }

    .loading-spinner,
    .loading-spinner * {
      transition-duration: 0.2s !important;
    }

    .loading-part {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      display: flex;
      padding-top: 16px;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
    }

    .global-loading-part {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      text-align: center;
    }

    button.v-btn {
      pointer-events: all;
    }
	}
</style>
